import { createFileRoute } from '@tanstack/react-router'
import { MailLinkFallback } from './-components/mail-link-fallback'
import {
	buildMailLinkSeo,
	mailLinkSearchSchema
} from './-lib/mail-link-fallback'

export const Route = createFileRoute('/(public)/verify-email')({
	ssr: true,
	validateSearch: mailLinkSearchSchema,
	head: ({ match }) =>
		buildMailLinkSeo({
			appLanguage: match.context.appLanguage,
			flow: 'verify_email',
			path: '/verify-email'
		}),
	component: VerifyEmailFallback
})

function VerifyEmailFallback() {
	const { appLanguage } = Route.useRouteContext()
	const { token } = Route.useSearch()
	return (
		<MailLinkFallback
			appLanguage={appLanguage}
			flow='verify_email'
			proof={token}
		/>
	)
}
